<script>

export default {
  name: "uConnectRegistrationSection2",
  data() {
    return {
    };
  },

}
</script>

<template>
  <div class="landing-page">
    <el-row class="container">
      <!-- Header Section -->
      <el-col :span="24" class="header-section">
        <h1 class="main-title">U-Connect: Your Partner in Driving Success and Expanding Revenue</h1>
        <p class="subtitle">
          Welcome to <b>U-Connect</b>, the innovative real estate platform that empowers professionals to collaborate on closing deals for clients
          seeking off-the-plan and new-build properties. U-Connect brings together real estate agents, buyer’s agents, finance brokers,
          accountants, and migration agents in a seamless network designed to connect clients with prime real estate opportunities while
          expanding each professional's reach and revenue potential.
        </p>
      </el-col>

      <!-- Main Content Section -->
      <el-row class="content-section">
        <!-- Left Column - Image -->
        <el-col :span="24">
          <div class="image-container">
            <img
                src="./../../../assets/u-connect-reg-section-2-backgroud.png"
                alt="UNIFI Property Platform Preview"
                class="feature-image"
            >
          </div>
        </el-col>

        <!-- Right Column - Features -->
        <el-col class="features-column" :span="24">
          <h2 class="features-title">Unlock New Revenue Streams and Market Access</h2>
          <p class="feature-description">By joining U-Connect, you gain more than just a
            platform; you gain a powerful business partner. Each
            deal closed is a shared success, with selling agents
            offering a portion of their commission to participating
            professionals who contribute to completing the
            transaction. This not only diversifies your income but
            also fosters a cooperative approach, creating win-win
            scenarios for all parties involved.</p>
        </el-col>
      </el-row>
    </el-row>
  </div>

</template>

<style scoped lang="scss">
.landing-page {
}

.header-section {
  text-align: start;
  padding: 20px 40px;
}

.main-title {
  color: #003333;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.subtitle {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 auto;
}

.content-section {
  margin-top: 40px;
  padding: 40px;
}

.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 300px;
  border-radius: 20px;
  overflow: hidden;
}
.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  overflow: hidden;
}

.features-title {
  display: flex;
  justify-content: start;
  color: #003333;
  font-size: 20px;
  font-weight: 600;
  margin: 30px 0;
}

.feature-description {
  color: #003333;
  font-size: 16px;
  font-weight: 200;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .content-section {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectRegistrationSection2.vue